export enum BrandTableColumnProps {
  NAME_TITLE = 'Name',
  NAME_DATA_INDEX = 'name',
  NAME_DEFAULT_SORT_ORDER = 'ascend',
  NAME_ICON_WIDTH = '20%',

  PRODUCTS_TITLE = 'Products',
  PRODUCTS_DATA_INDEX = 'product',
  PRODUCTS_DEFAULT_SORT_ORDER = 'descend',
  PRODUCTS_ICON_WIDTH = '20%',

  CATEGORIES_TITLE = 'Categories',
  CATEGORIES_DATA_INDEX = 'category',
  CATEGORIES_DEFAULT_SORT_ORDER = 'ascend',
  CATEGORIES_ICON_WIDTH = '20%',

  EMISSION_TITLE = 'Total Emissions (tonnes Co2e)',
  EMISSION_DATA_INDEX = 'emission',
  EMISSION_DEFAULT_SORT_ORDER = 'ascend',
  EMISSION_ICON_WIDTH = '20%',

  ACTION_ICON_TITLE = '',
  ACTION_ICON_DATA_INDEX = 'action',
  ACTION_ICON_WIDTH = '10%',
}

export enum BrandTableProps {
  EDIT_ICON_ALT = 'edit',
  DELETE_ICON_ALT = 'delete',
  DUMMY_DATA_PROP = 'Brand',
  DELETE_MODAL_HEADING = 'Do you want to delete this brand?',
  DELTE_MODAL_SUBHEADING = 'By deleting this brand, it will be permanently removed and you will not be to retrieve it later.',
}

export enum BrandProps {
  LOADING_TITLE = 'Loading...',
}
